import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-financial.dashboard',
  templateUrl: './financial.dashboard.component.html',
  styleUrls: ['./financial.dashboard.component.scss']
})
export class FinancialDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
